module.exports = __webpack_public_path__ + "1cc89e65fe7d0ccfd900cf252a90acdd.svg";